import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import HomeSlide from '../../../components/Home/Slides/HomeSlide';
import MilestoneSlide from '../../../components/Home/Slides/MilestoneSlide';
import './BackgroundDisplay.css';
import ToolSlide from '../Slides/ToolSlide';
import TutorDaySlide from '../Slides/TutorDaySlide';
import TaskSlide from '../Slides/TaskSlide';
import { GET, makeApiCal } from '../../../util';
import homeMedia1 from '../../../Resources/Slides/mainBg.json';
import LeaderboardSlide from "../Slides/LeaderboardSlide";

function BackgroundDisplay() {
	const sliderRef = useRef(null);
	const [background, setBackground] = useState(0);
	const [err, catchError] = useState(false);
	const [apiData, setApiData] = useState();

	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: homeMedia1,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};

	useEffect(() => {
		const action = {
			method: GET,
			route: 'v1/campaign/homeCard',
			storeData: setApiData,
			catchError: catchError,
		};
		makeApiCal(action);
	}, []);

	useEffect(() => {
		if (apiData) {
			let userData = {
				...apiData.campaignOrg,
			};
			localStorage.setItem('saleData', JSON.stringify(userData));
		}
	}, [apiData]);

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		autoplay: false,
		autoplaySpeed: 5000,
		// cssEase: 'linear',
		// dotsClass: 'sliderDots slick-dots',
		// touchThreshold: 500,
		// afterChange: (e) => {
		// 	// console.log(e);
		// 	setBackground(e);
		// },
		appendDots: (dots) => <ul>{dots}</ul>,
		customPaging: (i) => (
			<div className="slick-indicator"></div>
		),
	};

	return (
		<>
			<div className="homeDisplay">
				<div className="homeDisplaySlider">
					<Slider {...settings} ref={sliderRef}>
						{apiData?.homeCard && (
							<HomeSlide data={apiData?.homeCard} campaignOrg={apiData?.campaignOrg}/>
						)}
						{apiData?.rankingsPage && (
							<LeaderboardSlide
								data={apiData?.rankingsPage.teamRankings?.slice(0, 3)}
								deepLink={apiData?.homeCard?.deeplink}
							/>
						)}
						{apiData?.peakDayCard &&(
							<MilestoneSlide data={apiData?.peakDayCard}/>
						)}
						{apiData?.tutorOfTheDayCard && (
							<TutorDaySlide
								data={apiData?.tutorOfTheDayCard}
								rewardText={apiData?.awardsCard?.subText}/>
						)}
						{apiData?.statCard && <TaskSlide data={apiData?.statCard} />}
						{apiData?.toolsCard && <ToolSlide data={apiData?.toolsCard} />}
					</Slider>
				</div>
				<div className="homeDisplayAction">
					<img className="SliderButton left" onClick={() => sliderRef.current.slickPrev()} src="https://ali-cdn-cp-assets-public.classplus.co/web/courseWebview/content/carouselLeftHD.png" width={32} alt="carouselLeft" />
					<img className="SliderButton right" onClick={() => sliderRef.current.slickNext()} src="https://ali-cdn-cp-assets-public.classplus.co/web/courseWebview/content/carouselRightHD.png" width={32} alt="carouselRight"/>
				</div>
			</div>
		</>
	);
}

export default BackgroundDisplay;
